import config from 'Config';

const { navMenuLinks } = config;

type OS = {
  family?: string | undefined;
  version?: string | undefined;
};

// Splitting the logic into an explicit function so it can be reused in
// the static site's own useAppDownloadLinks implementation
const getAppDownloadLinks = ({ os, isMobile }: { os: OS; isMobile: boolean }) => {
  const { family = '', version } = os || {};
  // old Android cannot download native app
  const major = version?.split('.')[0];
  const isAncientAndroid =
    family === 'Android' && major && parseInt(major, 10) <= config.lite.maxVersion;
  const androidLink = isAncientAndroid ? navMenuLinks.download.lite : navMenuLinks.download.android;

  return {
    androidLink: isMobile ? androidLink : navMenuLinks.download.androidDesktop,
    iOSLink: isMobile
      ? 'https://itunes.apple.com/app/tinder-dating-chat-friends/id547702041'
      : navMenuLinks.download.iosDesktop,
  };
};

export default getAppDownloadLinks;
